const AZURE_HYPHEN_PLACEHOLDER = '__AZURE_HYPHEN__';

export function looksLikeAzureWikiEntry(name: string): boolean {
  if (!name) return false;
  const lower = name.toLowerCase();
  if (lower.includes('%2d')) return true;
  if (lower.includes('--')) return true;
  return false;
}

export function decodeAzureWikiName(name: string): string {
  if (!name) return name;
  let result = name;
  result = result.replace(/%2d/gi, AZURE_HYPHEN_PLACEHOLDER);
  result = result.replace(/--/g, ` ${AZURE_HYPHEN_PLACEHOLDER} `);
  result = result.replace(/-/g, ' ');
  result = result.replace(new RegExp(AZURE_HYPHEN_PLACEHOLDER, 'g'), '-');
  return result.replace(/\s+/g, ' ').trim();
}
